// Company Information
export const COMPANY_INFO = {
  name: "Energirude Eksperten",
  address: "Smørumnedrevej 27A, 2765 Smørum",
  phone: "21 82 80 00",
  email: "mail@energirudeeksperten.dk",
  cvr: "19658996",
  base: "Smørum",
  serviceArea: "Egedal, Nordsjælland og store dele af Sjælland",
  trustpilotUrl: "https://dk.trustpilot.com/review/energirudeeksperten.dk",
  trustpilotRating: "4.6",
  trustpilotCount: "21"
};

// Hero USPs
export const HERO_USPS = [
  "Gratis besøg og rådgivning",
  "Få overblik over din besparelse",
  "Specialister i energiruder",
  "Hurtig og personlig service"
];

// Navigation Menu
export const NAVIGATION_MENU = [
  { label: "Forside", href: "/" },
  {
    label: "Ydelser",
    href: "#",
    children: [
      { label: "Energiruder", href: "/energiruder" },
      { label: "Udskiftning af ruder", href: "/udskiftning-af-ruder" },
      { label: "Termoruder", href: "/termoruder" },
      { label: "Glasløsninger", href: "/glasloesninger" }
    ]
  },
  { label: "Gratis besøg", href: "/gratis-besoeg" },
  { label: "Om os", href: "/om-os" },
  { label: "Trustpilot", href: "/trustpilot" },
  { label: "Kontakt", href: "/kontakt" }
];

// CMS API Endpoints
const API_BASE_URL = "https://api.dev.auxo.dk/public";

// Helper to fetch all items from a CMS collection
export async function fetchCollection(collectionName) {
  try {
    const response = await fetch(`${API_BASE_URL}/content/${collectionName}`);
    if (!response.ok) throw new Error(`Failed to fetch ${collectionName}`);
    return await response.json();
  } catch (error) {
    console.error(`Error fetching collection ${collectionName}:`, error);
    return [];
  }
}

// Helper to fetch a single item by slug
export async function fetchBySlug(slug) {
  try {
    const response = await fetch(`${API_BASE_URL}/by-slug/${slug}`);
    if (!response.ok) throw new Error(`Failed to fetch by slug ${slug}`);
    return await response.json();
  } catch (error) {
    console.error(`Error fetching by slug ${slug}:`, error);
    return null;
  }
}

// Mock Testimonials Fallback
export const MOCK_TESTIMONIALS = [
  {
    id: "t1",
    name: "Susanne kretzschmer",
    rating: 5,
    text: "<p>Allerede ugen efter at jeg havde fået god vejledning og et godt tilbud på nye ruder, blev der isat 8 store ruder i min havestue. Morten kom til aftalt tid hver gang, han var hurtig, dygtig og prisen var fair. Der blev ryddet op og ruderne blev fjernet. Jeg oplever Morten som en meget rar og pålidelig person, hvorfor jeg til enhver tid vil anbefale energieksperten.</p>"
  },
  {
    id: "t2",
    name: "Gienette Delphine Passera",
    rating: 5,
    text: "<p>Energieksperten lever op til deres navn. Jeg er SÅ tilfreds med Mortens arbejde og udførelse af udskiftning af de gode energiruder. Han er dygtig, hurtig og rimelig med prisen. Meget pålidelig og et virkeligt rart menneske. Jeg kan kun give mine varmeste anbefalinger her 🙂</p>"
  },
  {
    id: "t3",
    name: "Patrick HIckey",
    rating: 5,
    text: "<p>Det var en total overskudsoplevelse. Svar indenfor et par timer omkring at få et tilbud på et større udskiftningsprojekt - gamle ruder ud, nye ind. Et par dage efter havde vi haft besøg og sad med et tilbud i hænderne. De havde allerede vundet på alle do indledende parametre, nu vandt de også på prisen. Herefter holdt alle aftaler vi lavede. Så her POST-Corona er vi ikke forvænt med håndværkere der både holder aftaler, pris og så oveni købet yder en formidabel service (oprydning, bortkørsel af gamle ruder o.a.) - så jo en kanonoplevelse tak til begge glasfolkene. Mvh Patrick & Wicki</p>"
  },
  {
    id: "t4",
    name: "Dan Nielsen",
    rating: 5,
    text: "<p>Alt var bare perfekt, og havde jeg kunne give 10 stjerner til Energirude Eksperten v. Morten, havde jeg gjort det. Jeg skrev til firmaet en søndag og fik svar retur samme dag. Han kontaktede mig dagen efter telefonisk og kom samme dag for at besigtige. Alle aftaler blev overholdt, og der blev ryddet op, og affald kørt væk. Perfekt.</p>"
  },
  {
    id: "t5",
    name: "Ole Stougaard",
    rating: 5,
    text: "<p>Morten er bare en super glarmester. Udskiftede vores gamle termoruder. Laver perfekt arbejde til en fornuftig pris. Yderst behagelig at samarbejde med, overholder aftaler, kommunikerer hurtigt og effektivt. Bedre håndværker fås ikke. Vh Ole Stougaard.</p>"
  },
  {
    id: "t6",
    name: "Claes Veifert",
    rating: 5,
    text: "<p>Energirude Eksperten har udskiftet alle mine gamle termoruder til nye energiruder. Dette arbejde er udført til UG med kryds og slange. Morten er en utrolig rar, venlig og omhyggelig person, der har overholdt alle aftaler til punkt og prikke. Kan kun anbefale Morten og Energirude Eksperten på det kraftigste.</p>"
  }
];

// FAQ data for Homepage and Service pages (each with 5 targeted questions, answers 3-5 lines)
export const HOMEPAGE_FAQS = [
  {
    id: "home-faq-1",
    question: "Hvor meget kan jeg spare på varmeregningen ved at skifte til energiruder?",
    answer: "<p>Ved at udskifte ældre termoruder med moderne energiruder kan du typisk spare mellem 15% og 30% på varmeregningen afhængigt af boligens opvarmningsform. En moderne energirude holder mere end dobbelt så godt på varmen som en ældre traditionel termorude. Samtidig elimineres det ubehagelige træk og kuldenedfald ved vinduerne, hvilket forbedrer indeklimaet mærkbart i hele boligen i Egedal, Nordsjælland og store dele af Sjælland.</p>"
  },
  {
    id: "home-faq-2",
    question: "Skal hele vinduesrammen udskiftes, eller kan I nøjes med at skifte glasset?",
    answer: "<p>I langt de fleste tilfælde er dine eksisterende træ- eller plastrammer i fin stand, så vi kun behøver at udskifte selve ruden. Dette sparer dig for store omkostninger til helt nye vinduer, malerarbejde og murerreparationer omkring vinduesåbningerne. Vores glarmester vurderer altid rammernes tilstand under det gratis opmålingsbesøg, så du er garanteret en langtidsholdbar løsning.</p>"
  },
  {
    id: "home-faq-3",
    question: "Hvad koster et gratis opmålingsbesøg, og forpligter det mig til noget?",
    answer: "<p>Et opmålingsbesøg hos Energirude Eksperten er 100% gratis og helt uforpligtende for boligejere i Egedal, Nordsjælland og store dele af Sjælland. Vi har base i Smørum, kommer forbi din bolig, måler dine ruder præcist op, undersøger rammernes beskaffenhed og rådgiver om de optimale energiglasløsninger. Efterfølgende modtager du et fast skriftligt tilbud med gennemskuelige priser, som du i ro og mag kan tage stilling til.</p>"
  },
  {
    id: "home-faq-4",
    question: "Hvorfor dannes der dug på ydersiden eller indersiden af mine ruder?",
    answer: "<p>Dug på indersiden opstår, når varm og fugtig indeluft rammer et koldt glaslag, hvilket ofte indikerer dårlig isoleringsevne i ruden eller for høj luftfugtighed. Dug på ydersiden er derimod et positivt sundhedstegn på, at ruden isolerer fantastisk og holder varmen inde i boligen. Oplever du derimod dug eller grå slør inde mellem de to glaslag, er termoruden punkteret og bør udskiftes for at genvinde isoleringsevnen.</p>"
  },
  {
    id: "home-faq-5",
    question: "Hvor lang tid tager selve monteringen, og rydder I pænt op bagefter?",
    answer: "<p>En standard udskiftning af ruder i et parcelhus tager som regel kun én enkelt arbejdsdag, og du behøver ikke frygte åbne vindueshuller natten over. Vores erfarne glarmestre monterer hurtigt og præcist, afrenser de nye ruder og fuger professionelt efter gældende standarder. Vi tager alle gamle ruder og affald med os til miljørigtig genanvendelse og efterlader dit hjem pænt og ryddeligt.</p>"
  },
  {
    id: "home-faq-6",
    question: "Hvilken garanti ydes der på nye energiruder og glarmesterarbejdet?",
    answer: "<p>Når du får udskiftet ruder hos Energirude Eksperten, er du dækket af en fuld 5 års fabriksgaranti mod punkterede ruder og fabrikationsfejl på glasset. Derudover yder vi fuld garanti på vores glarmesterfaglige monteringsarbejde og tætning, så du er sikret en langtidsholdbar løsning. Skulle der mod forventning opstå problemer med en rude, rykker vi hurtigt ud og udbedrer det uden ekstra omkostninger.</p>"
  }
];

export const SERVICE_FAQS = {
  '/energiruder': [
    {
      id: "energi-1",
      question: "Hvad er forskellen på en almindelig termorude og en energirude?",
      answer: "<p>En traditionel termorude består blot af to lag almindeligt glas med atmosfærisk luft imellem og har en høj U-værdi omkring 2,8 til 3,0. En moderne energirude har derimod en mikroskopisk usynlig metalbelægning og er fyldt med isolerende argongas mellem glaslagene. Dette sender rumvarmen tilbage i stuen og reducerer varmetabet med op til 60%, hvilket giver en lav U-værdi helt ned til 1,1 for 2-lags og 0,6 for 3-lags ruder.</p>"
    },
    {
      id: "energi-2",
      question: "Hvad betyder det, at en energirude har en 'varm kant'?",
      answer: "<p>I ældre ruder er afstandsprofilet langs glaskanten lavet af aluminium eller stål, som leder kulde direkte ind og danner en kuldebro langs kanten. En energirude med 'varm kant' benytter i stedet et højisolerende komposit- eller plastmateriale mellem glassene. Det hæver temperaturen i rudens randområde markant, modvirker kondensdannelse og reducerer risikoen for fugtskader og skimmelsvamp i trærammen.</p>"
    },
    {
      id: "energi-3",
      question: "Bør jeg vælge 2-lags eller 3-lags energiruder til mine eksisterende vinduer?",
      answer: "<p>Valget afhænger primært af tykkelsen og bæreevnen i dine nuværende vinduesrammer samt boligens øvrige isoleringsniveau. 2-lags energiruder passer i næsten alle eksisterende vinduesrammer og giver en fremragende energiopgradering uden ændringer i profilerne. 3-lags ruder isolerer endnu bedre, men vejer mere og kræver en dybere fals, hvilket vi altid vurderer under vores gratis besigtigelse.</p>"
    },
    {
      id: "energi-4",
      question: "Kan energiruder også dæmpe støj udefra og overophedning fra solen?",
      answer: "<p>Ja, moderne energiruder kan skræddersyes med kombinationsglas, der både isolerer mod kulde, dæmper udefrakommende trafikstøj og reducerer solindfald. Ved at vælge lamineret lydglas eller solafskærmende glasbelægning opnår du optimal komfort i rum med store sydvendte vinduespartier eller boliger tæt på befærdede veje. Vi rådgiver dig om de bedste glaskombinationer, så du får en løsning tilpasset boligens orientering.</p>"
    },
    {
      id: "energi-5",
      question: "Hvor hurtigt tjener investeringen i nye energiruder sig hjem?",
      answer: "<p>Tilbagebetalingstiden på udskiftning af ruder i eksisterende rammer ligger typisk på mellem 4 og 8 år afhængig af boligens varmekilde og energipriser. Da du bevarer de eksisterende vindueskarme og kun investerer i nyt glas, er etableringsomkostningen markant lavere end ved komplette vinduesudskiftninger. Samtidig øges boligens samlede værdi og energimærke øjeblikkeligt fra den dag, de nye ruder monteres.</p>"
    }
  ],
  '/udskiftning-af-ruder': [
    {
      id: "udskift-1",
      question: "Hvordan foregår selve processen ved udskiftning af ruder hos jer?",
      answer: "<p>Processen starter med et uforpligtende og gratis opmålingsbesøg, hvor vi gennemgår dine ruder og rådgiver om den optimale glastype. Når du har godkendt vores faste tilbud, sætter vi ruderne i produktion efter millimeterpræcise mål hos førende danske glasleverandører. På den aftalte monteringsdag fjerner vi de gamle ruder, renser falsen, isætter de nye energiglas med nye tætningslister og rydder grundigt op bagefter.</p>"
    },
    {
      id: "udskift-2",
      question: "Kan I udskifte ruder i alle typer vinduesrammer af træ, plast og træ/alu?",
      answer: "<p>Ja, vi har mange års erfaring som glarmestre og kan montere nye ruder i stort set alle fabrikater og materialer, herunder træ, plast og træ/alu. Uanset om dine vinduer er fra Rationel, KPK, Velfac, Outline eller en lokal snedkermodel, tilpasser vi glas og glaslister præcist dertil. Hvis eksisterende trælister er møre eller beskadigede, monterer vi gerne nye vedligeholdelsesfrie bundglaslister i aluminium.</p>"
    },
    {
      id: "udskift-3",
      question: "Er det nødvendigt at male eller udbedre karme efter rudens udskiftning?",
      answer: "<p>Normalt er der intet behov for efterfølgende malerarbejde eller spartling, da vi arbejder yderst skånsomt indefra eller udefra i selve glasfalsen. Vi bevarer den eksisterende vinduesramme og vinduesplade intakt, så du slipper for de støvede og omkostningstunge håndværkerfaser, der normalt følger med en total vinduesudskiftning. Du kan således fortsætte hverdagen uforstyrret, mens arbejdet udføres.</p>"
    },
    {
      id: "udskift-4",
      question: "Hvad sker der med de gamle ruder, når I har taget dem ud?",
      answer: "<p>Vi sørger for fuld bortskaffelse af alle udtjente ruder og affald fra arbejdet som en fast del af vores samlede service. De gamle ruder køres til autoriserede modtagestationer, hvor glas og metaller sorteres og sendes til miljøvenlig genanvendelse. Du skal altså hverken bekymre dig om tunge løft, oprydning eller bortkørsel af byggeaffald fra din matrikel.</p>"
    },
    {
      id: "udskift-5",
      question: "Hvor lang garanti yder I på nye ruder og glarmesterarbejdet?",
      answer: "<p>Alle vores leverede energiruder og termoruder leveres med fuld 5 års fabriksgaranti mod indvendig dug og punktering i henhold til Glasindustriens retningslinjer. Som professionelt glarmesterfirma garanterer vi desuden håndværksmæssig korrekt montage og korrekt fugearbejde, så du er sikret maksimal levetid. Med base i Smørum er vi altid tæt på, hvis du mod forventning skulle have brug for service.</p>"
    }
  ],
  '/termoruder': [
    {
      id: "termo-1",
      question: "Hvordan ser jeg med sikkerhed, om en termorude er punkteret?",
      answer: "<p>En punkteret termorude kendetegnes ved, at der dannes dug, fugtdråber, kalkstriber eller et gråligt slør mellem glaslagene, som ikke kan vaskes væk udefra eller indefra. Fænomenet opstår, når kantforseglingen omkring ruden med årene bliver utæt, så atmosfærisk luft og fugt trænger ind i hulrummet. Når ruden er punkteret, mister den sin isolerende gas og bør udskiftes for at genoprette isoleringsevnen og udsynet.</p>"
    },
    {
      id: "termo-2",
      question: "Kan en punkteret termorude repareres, eller skal den udskiftes med en ny?",
      answer: "<p>En punkteret termorude kan desværre ikke repareres, tørres eller tætnes igen, da den kemiske tørremasse i afstandsprofilet er mættet med fugt. Den eneste holdbare og professionelle løsning er at udskifte selve ruden med en ny moderne energirude. Da du beholder den eksisterende ramme og karm, er en udskiftning af ruden dog en overkommelig og hurtig reparation, der samtidig forbedrer boligens varmeregning markant.</p>"
    },
    {
      id: "termo-3",
      question: "Hvorfor opstår der kondens og dug på indersiden af mine termoruder?",
      answer: "<p>Kondens på indersiden skyldes en kombination af høj luftfugtighed i hjemmet og for kold overfladetemperatur på det inderste glaslag. Ældre termoruder har dårlig isoleringsevne, hvilket gør overfladen iskold om vinteren, hvor fugt fra madlavning, bad og vejrtrækning sætter sig som vandperler. Ved at skifte til energiruder med varm kant hæves glastemperaturen betydeligt, hvilket minimerer risikoen for indvendig kondens.</p>"
    },
    {
      id: "termo-4",
      question: "Hvad er den gennemsnitlige levetid på en moderne termorude?",
      answer: "<p>En kvalitetstermorude holder typisk mellem 20 og 30 år, afhængig af vinduets orientering mod sol, vind og vejrlig samt kvaliteten af montagen og tætningen. Ruder mod syd og vest udsættes for kraftige temperaturudsving og sollys, hvilket stiller ekstra høje krav til fugearbejdet og kantforseglingen. Vores faglærte montage sikrer optimal dræning og ventilation i falsen, så fugt ledes bort og rudens levetid maksimeres.</p>"
    },
    {
      id: "termo-5",
      question: "Hvorfor kan jeg ikke bare udskifte én enkelt rude i et fag med flere vinduer?",
      answer: "<p>Du kan sagtens vælge kun at udskifte den ene punkterede rude, og vi rådgiver dig altid ærligt om den mest økonomiske løsning. Hvis de øvrige ruder er af ældre dato, kan der dog være en lille forskel i glasets farvetone eller lysrefleksion i forhold til en spritny energirude. Derfor vælger mange husejere at skifte hele facadepartiet på én gang for at opnå et ensartet udtryk og ensartet isolering i rummet.</p>"
    }
  ],
  '/glasloesninger': [
    {
      id: "glas-1",
      question: "Hvilke typer specialglas og funktionelle glasløsninger tilbyder I?",
      answer: "<p>Vi leverer og monterer et bredt udvalg af specialglas til både private hjem og erhverv i Egedal, Nordsjælland og store dele af Sjælland. Vores sortiment omfatter effektive støjdæmpende lydruder, solafskærmende energiglas, satineret/matteret privatlivsglas, samt hærdet og lamineret sikkerhedsglas. Hver løsning tilpasses nøjagtigt dine arkitektoniske ønsker, rammemål og behov for komfort, tryghed og lysindfald.</p>"
    },
    {
      id: "glas-2",
      question: "Hvor meget støj kan en lyddæmpende rude reelt fjerne i hverdagen?",
      answer: "<p>En professionel lydrude kan reducere udefrakommende støj med 36 til over 45 dB sammenlignet med ca. 30 dB for en standardrude. Da decibelskalaen er logaritmisk, opleves en reduktion på blot 3 dB som en hørbar forbedring, mens en reduktion på 10 dB halverer den opfattede støj. Bor du ud til en trafikeret vej, togbane eller skole, vil lydruder skabe markant mere ro og forbedre nattesøvnen mærkbart.</p>"
    },
    {
      id: "glas-3",
      question: "Hvordan fungerer solafskærmende glas uden at mørklægge rummet?",
      answer: "<p>Solafskærmende energiglas er forsynet med en avanceret spektralselektiv coating, som reflekterer solens usynlige infrarøde varmestråler bort, mens det meste af det synlige dagslys lukkes igennem. Det forhindrer drivhuseffekt og overophedning i syd- og vestvendte stuer eller udestuer om sommeren, uden at udsigten forringes. Om vinteren fungerer ruden som en traditionel energirude og holder varmen inde i boligen.</p>"
    },
    {
      id: "glas-4",
      question: "Hvad er forskellen på hærdet sikkerhedsglas og lamineret glas?",
      answer: "<p>Hærdet glas er varmebehandlet, så det er op til 5 gange stærkere end almindeligt glas; hvis det knuses, granulerer det i tusindvis af små, ufarlige stykker uden skarpe kanter. Lamineret glas består af to lag glas smeltet sammen med en stærk, elastisk plastfolie imellem, som holder glasskårene sammen ved brud og forhindrer indbrud eller gennemfald. Begge glastyper opfylder Bygningsreglementets krav til personsikkerhed ved døre og gulvhøje partier.</p>"
    },
    {
      id: "glas-5",
      question: "Kan matteret eller satineret glas give privatliv uden at miste lyset?",
      answer: "<p>Ja, syreætset satineret glas (også kendt som matteret glas eller frostet glas) spreder lyset jævnt og forhindrer direkte indkig både dag og nat. Det er den ideelle løsning til badeværelsesvinduer, glasfelter i eller ved hoveddøren samt kontorafskærmninger, hvor man ønsker fuldt dagslys uden nysgerrige blikke. Overfladen er silkeblød, rengøringsvenlig og modstandsdygtig over for fedtfingre modsat traditionelt sandblæst glas.</p>"
    }
  ],
  '/gratis-besoeg': [
    {
      id: "besoeg-1",
      question: "Hvad indebærer et gratis besøg fra Energirude Eksperten?",
      answer: "<p>Når du bestiller et gratis besøg, kommer vores faglærte glarmester ud til din adresse i Egedal, Nordsjælland og store dele af Sjælland og gennemgår alle dine vinduer. Vi har base i Smørum, foretager præcise opmålinger, kontrollerer for punkterede ruder, undersøger rammernes tilstand og afdækker dine ønsker til isolering, støjreduktion eller solafskærmning. Besøget munder ud i professionel rådgivning om de mest fordelagtige løsninger for netop din bolig.</p>"
    },
    {
      id: "besoeg-2",
      question: "Hvor lang tid varer et opmålingsbesøg typisk i en almindelig bolig?",
      answer: "<p>Et typisk opmålingsbesøg tager mellem 30 og 45 minutter afhængigt af husets størrelse og antallet af vinduer, der skal gennemgås. Vi tager os god tid til at lytte til dine ønsker, besvare dine spørgsmål og gennemgå mulige tilvalg som varm kant, lydglas eller solfilter. Vi tilpasser besøget efter din tidsplan, så det passer ubesværet ind i din hverdag.</p>"
    },
    {
      id: "besoeg-3",
      question: "Hvor hurtigt efter besøget modtager jeg det skriftlige tilbud?",
      answer: "<p>Du modtager som regel dit detaljerede og specificerede tilbud på e-mail inden for 24 til 48 timer efter opmålingsbesøget. Tilbuddet indeholder en fast, gennemskuelig pris inklusiv opmåling, kvalitetsruder, professionel montering, tætning og bortkørsel af de gamle ruder. Der tilkommer ingen skjulte gebyrer eller uventede ekstraregninger, så du ved præcist, hvad opgaven koster.</p>"
    },
    {
      id: "besoeg-4",
      question: "Hvilke geografiske områder dækker I med det gratis besøg?",
      answer: "<p>Vi har vores faste base i Smørum og kører dagligt ud til gratis rådgivnings- og opmålingsbesøg i Egedal Kommune, Nordsjælland og store dele af Sjælland. Det dækker blandt andet Smørum, Måløv, Ballerup, Stenløse, Ølstykke, Veksø, Frederikssund, Hillerød, Birkerød, Furesø, Farum og mange andre sjællandske byer. Uanset hvor i området du bor, kommer vi gerne forbi og vurderer dine ruder uden beregning.</p>"
    },
    {
      id: "besoeg-5",
      question: "Hvad sker der, hvis jeg efter tilbuddet beslutter mig for ikke at gå videre?",
      answer: "<p>Vores gratis besøg og tilbud er 100% uforpligtende, og der følger ingen krav eller gebyrer med, hvis du vælger ikke at benytte tilbuddet. Vi ønsker glade og trygge kunder, og vi tror på, at vores faglige rådgivning, høje kvalitet og konkurrencedygtige priser taler for sig selv. Du kan derfor med fuld ro i sindet booke et besøg og få et professionelt grundlag at træffe din beslutning ud fra.</p>"
    }
  ]
};
